import { useEffect } from 'react'

import { useQuery, useQueryClient } from '@tanstack/react-query'

import { GetShortTokenViewModel } from '@/types/cml-api'

import { useUserToken } from '@/features/user-token-provider/use-user-token'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useInteractifyInit = (shortSlug: string, enabled = false) => {
    const queryClient = useQueryClient()
    const { userToken } = useUserToken()

    const result = useQuery<GetShortTokenViewModel>({
        queryKey: QueryKeys.Interactify.ShortInit(shortSlug, userToken),
        queryFn: () =>
            fetchRequest({
                endpoint: `/videos/short-video/get-token/${shortSlug}?ut=${userToken}`,
                serviceName: 'cml',
                method: 'GET',
            }),
        enabled: enabled && !!shortSlug && !!userToken,
    })

    useEffect(() => {
        if (enabled) return

        queryClient.resetQueries({
            queryKey: QueryKeys.Interactify.ShortInit(shortSlug, userToken),
        })
    }, [enabled, queryClient, shortSlug, userToken])

    return {
        data: enabled ? result.data : undefined,
        isLoading: enabled && result.isLoading,
    }
}
